import React, { Component } from 'react';
import { SelectionControlGroup, Grid, Cell, DialogContainer } from 'react-md';
import { Link } from 'react-router-dom';
import he from 'he';

import './Welcome.css';

import { state } from '../services/state';

class Welcome extends Component {
	constructor(props) {
		super(props);
		this.state = {
			jobType: state.jobType,
			showWarning: false
		};
	}

	// componentWillMount() {
	// 	this.setState({
	// 		jobType: state.jobType
	// 	})
	// }

	handleChange = (value, event) => {
		console.log('change event: ', value);
		state.jobType = value;
		this.setState({
			jobType: value
		});
		if (value === 'other') {
			this.setState({ showWarning: true });
		}
	};

	hideWarning = () => {
		this.setState({ showWarning: false });
	};

	render() {
		const { showWarning } = this.state;

		const actions = [];
		actions.push(
			<button className="primary-button" onClick={this.hideWarning}>
				OK
			</button>
		);

		const getWarningMessage = function() {
			const content =
				window.freshAssetUploaderWarningMessageContent ||
				`
				<h2 class="text-center">IMPORTANT</h2>
				<p>If you are unable to provide pdf(s) or hard copy(s), Image Mill can do so for you.</p>
				<p>Your rep will contact you regarding fees and/or timing.</p>
				`;
			return {
				__html: he.decode(content)
			};
		};

		return (
			<div className="Welcome">
				<DialogContainer
					id="simple-list-dialog"
					visible={showWarning}
					actions={actions}
					onHide={this.hideWarning}
				>
					<div dangerouslySetInnerHTML={getWarningMessage()} />
				</DialogContainer>
				<Grid>
					<Cell
						size={6}
						tabletOffset={1}
						desktopOffset={3}
						className="title-wrapper"
					>
						<h2 className="sub-section-title">
							Welcome, what will you be uploading today?
						</h2>
					</Cell>
				</Grid>
				<Grid>
					<Cell
						size={6}
						tabletOffset={1}
						desktopOffset={3}
						className="welcome-selection-wrapper"
					>
						<SelectionControlGroup
							id="welcome-selection"
							name="welcome-selection"
							type="radio"
							label="Welcome, what will you be uploading today?"
							defaultValue={this.state.jobType}
							controls={[
								{
									label:
										'A PDF proof of all items needed for your project',
									value: 'proof'
								},
								{
									label:
										'Concept Art or other Visual References',
									value: 'art'
								},
								{
									label: 'Other',
									value: 'other'
								}
							]}
							checkedRadioIcon={
								<div className="radio-icon checked-radio-icon" />
							}
							uncheckedRadioIcon={
								<div className="radio-icon unchecked-radio-icon" />
							}
							onChange={this.handleChange}
						/>
					</Cell>
				</Grid>
				<Grid className="next-wrapper">
					<Cell size={6} tabletOffset={1} desktopOffset={3}>
						<Link to="/info" className="primary-button">
							Next{' '}
							<i className="uploader-icon uploader-icon-Next-Arrow" />
						</Link>
					</Cell>
				</Grid>
			</div>
		);
	}
}

export default Welcome;



// WEBPACK FOOTER //
// ./src/pages/Welcome.js